export const fmt = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 })
export const money = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' })